import { Error } from '@brafton/skynet-angular-security-service';

export class ErrorService {
  public static getError(error: Error): string {
    let errorMessage = '[Error] ';
    let knownErrorMessage = '';
    const unKnownErrorMessage = ' Unknown Error';

    // both uppper and lower case interogation...
    if (
      error &&
      error.details &&
      error.details.details &&
      (error.details.details as any).InnerException &&
      (error.details.details as any).InnerException.Message
    ) {
      knownErrorMessage += `: ${(error.details.details as any).InnerException.Message} `;
    } else if (
      error &&
      error.details &&
      error.details.details &&
      error.details.details.innerException &&
      error.details.details.innerException.message
    ) {
      knownErrorMessage += `: ${error.details.details.innerException.message} `;
    }
    // both uppper and lower case interogation...
    else if (error && error.details && error.details.details && (error.details.details as any).Message) {
      knownErrorMessage += `: ${(error.details.details as any).Message} `;
    } else if (error && error.details && error.details.details && error.details.details.message) {
      knownErrorMessage += `: ${error.details.details.message} `;
    } else if (error && error.details && error.details.message) {
      knownErrorMessage += `: ${error.details.message} `;
    } else if (error && error.statusText) {
      knownErrorMessage += `: ${error.statusText} `;
    }

    if (!knownErrorMessage) {
      errorMessage += unKnownErrorMessage;
    } else {
      errorMessage += knownErrorMessage;
    }

    return errorMessage;
  }
}
